import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData, postQuery, uploadFile } from '../utils'
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import * as Highcharts from 'highcharts';
import { connect } from "react-redux";
import { Table, Button, Select, Upload, message, Card, Form, Row, Col, Modal, Input } from 'antd';
import { InboxOutlined, CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { busyGif } from '../img';
const { Option } = Select;
const { Item } = Form;
const { Dragger } = Upload;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

interface Facility {
    Id: string;
    name: string;
    stateCode: string;
    lga: string;
    state: string;
    [key: string]: Facility[keyof Facility];
}

class Site extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        data: [],
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 10,
            sorter: {
                field: "name",
                order: "asc"
            }
        },
        loading: false,
            confirmLoading: false,
            fLoading: false,
        title: 'New Site',
        site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        searchText: "",
        visible: false,
            hideUpload: false,
            showDetails: false,
        facility:
        {
            id: 0,
            name: '',
            stateCode: '',
            active: 0,
            inactive: 0,
            totalClients: 0,
            totalOnArt: 0,
            newClients: 0
        }
        };

    async componentDidMount()
    {
        let facility: Facility = { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' };
        this.setState({ site: facility });

        const { pagination } = this.state;

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });
    }
    
    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }  
 
    async getItems(params: any)
    {
        this.setState({ loading: true });
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        // var sortField = params.sortField;
        // var sortOrder = params.sortOrder;
        let el = this;

        var query = `/api/Site/getSites?itemsPerPage=${results}&pageNumber=${page}&searchText=${searchText}`;

        let res = await fetchData(query);

        const { pagination } = el.state;
            pagination.total = res.totalItems;           
            el.setState({
                data: res.sites,
                pagination,
                loading: false 
            });                      

        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.name.toString().match(reg) || record.stateCode.toString().match(reg) || record.datimCode.toString().match(reg);

                    if (!match)
                    {
                        return null;
                    }
                    return {
                        ...record,
                        name: (<span> {record.name.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }

    handleChange(value: any)
    {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            //sortField: pagination.sorter.field,
            //sortOrder: pagination.sorter.order
        });
    }
    
    onInputChange(e: any)
    {
        let searchTerm = e.target.value.trim();
        this.setState({searchText: searchTerm});       
    }
      
    onSearch()
    {
        let el = this;
        const { pagination } = el.state;
        if (!el.state.searchText || el.state.searchText.length < 1)
        {
            message.error('Please provide a facility name');
            return;
        }
        this.getItems({
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        });
    }

    edit(data: any, row: any)
    {
        this.setState({ visible: true, title: 'Update Site', buttonText: 'Update', site: data });
    }

    Add()
    {
        this.setState({ visible: true, title: 'Add Site', buttonText: 'Add', site: { id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' } });
    }

    fileControlClicked()
    {
        var ecl = document.getElementById("txSel");
        if (ecl)
            ecl.click();
    }

    dwnTemplate()
    {
        //@ts-ignore
        window.location = "/templates/facilites.xlsx";
    }

    startUpload() {
        this.setState({hideUpload: true});
    }

    async process()
    {
        if (!this.state.site.name)
        {
            message.error('Provide all required input and try again');
            return;
        }
        let url = '';
        let payload = {};
        // @ts-ignore
        if (!this.state.site.id || this.state.site.id.length < 1) 
        {
            url = '/addSite';
            payload = { name: this.state.site.name, stateCode: this.state.site.stateCode, lga: this.state.site.lga, siteId: this.state.site.siteId, state: this.state.site.state };
        }
        else
        {
            url = '/updateSite';
            // @ts-ignore
            payload = { id: this.state.site.id, name: this.state.site.name, stateCode: this.state.site.stateCode, lga: this.state.site.lga, siteId: this.state.site.siteId, state: this.state.site.state };
        }

        const { pagination } = this.state;
        let params = {
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            //sortField: pagination.sorter.field,
            //sortOrder: pagination.sorter.order
        };

        this.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(payload));
        this.setState({ confirmLoading: false });
        if (res.code > 0) {
            this.getItems(params);
            this.setState({ visible: false });
            message.success(res.message);
        }
        else {
            message.error(res.message);
        }
    }
        
    exit() {
        this.setState({
            visible: false, hideUpload: false
        });
    }
    
    textChange(feture: any, e: any)
    {
        let site: Facility = this.state.site;        
        site[feture] = e.target.value;
        this.setState({ site });
    }

    async export()
    {
        this.setState({ confirmLoading: true });
        let res = await fetchData('/api/Site/exportSites');
        this.setState({ confirmLoading: false });  
        if (res.code < 1) 
        {
            alert(res.message);
        }
        else
        {
            console.log(res.asset);
            window.location = res.asset;
        }
    }

    async upload(file: any)
    {
        //let file = e.target.files[0];
        let form = new FormData();
        form.append('file', file);
        form.append('fileName', file.name);
        console.log(form);
        this.setState({ confirmLoading: true });
        let res = await uploadFile('/api/Site/uploadSites', form);
        this.setState({ confirmLoading: false });

        if (res.code < 1)
        {
            message.error(res.message);
        }
        else
        {
            message.success(res.message);
            const { pagination } = this.state;
            this.setState({ hideUpload: false });
            this.getItems({
                results: pagination.pageSize,
                searchText: this.state.searchText,
                page: pagination.current,
                sortField: pagination.sorter.field,
                sortOrder: pagination.sorter.order
            });
        }
    }

    async getFacilityData(data: any)
    {
        let el = this;
        el.setState({ fLoading: true, facility: data});
        el.getPvlsTrends(data.id);  
        document.getElementById('pvls').innerHTML = '';
        document.getElementById('pbs').innerHTML = '';
        document.getElementById('band').innerHTML = '';
        document.getElementById('pie-agg').innerHTML = '';           
    }

    async getPvlsTrends(site)
    {
        let el = this;
        el.setState({ showDetails: true  });

        let res = await fetchData(`/api/Stats/getPvlsTrends?site=` + site);
    
        if (res.length > 0)
        {
            let eligibles: number[] = [];
            let tested: number[] = [];
            let suppressed: number[] = [];
            let unsuppressed: number[] = [];
            let percentageSuppression: number[] = [];
            let categories: string[] = [];
                       
            res.map(function (p: any)
            {
                eligibles.push(p.eligible);
                tested.push(p.tested);
                suppressed.push(p.suppressed);
                unsuppressed.push(p.unsuppressed);

                if (p.eligibles > 0 && p.suppressed > 0)
                {
                    percentageSuppression.push(((p.suppressed) * 100) / p.eligibles);
                }
                else
                {
                    percentageSuppression.push(0);
                }

                if (p.sampleDate !== undefined && p.sampleDate.length > 0)
                {
                    categories.push(p.sampleDate);
                }  
            });

            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pvls',
                        type: 'column'
                    },
                    title: {
                        text: 'PVLS Coverage within last 12 months'
                    },
                    xAxis: {
                        categories: categories, crosshair: true, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'PVLS'
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        }
                    },
                    colors: ['rgb(124,181,236)', 'rgb(144,237,125)', 'rgb(67,67,72)', '#7030A0', '#4472C4'], //#7030A0
                    series: [                      
                        //{ name: 'Eligible', data: eligibles, type: 'column' },
                        { name: 'Tested', data: tested, type: 'column', pointPadding: 0 },
                        { name: 'Suppressed', data: suppressed, type: 'column', pointPadding: 0 },
                        { name: 'Unsuppressed', data: unsuppressed, type: 'column', pointPadding: 0 }
                    ]
                });
        }

        el.getStatsBySite(site);
    }

    async getStatsBySite(site)
    {
        let el = this;
        let res1 = await fetchData(`/api/Stats/getStatsBySite?site=` + site);
        
        if (res1.groupCounts.length > 0)
        {
            let actives: any[] = [];
            let tx_curr_ages: any[][] = [];
            let maleCounts: number[] = [];
            let femaleCounts: number[] = [];
            let malePbs: number[] = [];
            let femalePbs: number[] = [];
            let percentagePbsCoverage: number[] = [];
            let categories: string[] = [];

            // Create the chart               
            res1.groupCounts.map(function (p: { active: number, maleCount: number, femaleCount: number, malePbs: number, femalePbs: number })
            {
                actives.push(p.active);
                maleCounts.push(p.maleCount);
                malePbs.push(p.malePbs);
                femalePbs.push(p.femalePbs);
                femaleCounts.push(p.femaleCount);

                if (p.active > 0 && p.malePbs > 0 && p.femalePbs > 0)
                {
                    percentagePbsCoverage.push(((p.malePbs + p.femalePbs) * 100) / p.active);
                }
                else
                {
                    percentagePbsCoverage.push(0);
                }

            });

            tx_curr_ages = res1.ageBands;

            //let colors = ['#95CEFF', '#50B432', '#24CBE5', '#ff7043', '#DDDF00', '#24CBE5',
            //    '#64E572', '#FF9655', '#FFF263', '#6AF9C4'];

            //let colors = ['#3aacae', '#50B432', '#24CBE5', '#3aacae', '#95cc3e'];

            var pbsToolTip =
            {
                headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td colspan="2">{point.key}</td></tr>',
                pointFormat: '<tr style="font-size:11px;background-color: #fff"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:,.1f}%</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            };

            //Render PBS Coverage
            Highcharts.chart(
                {
                    chart: {
                        renderTo: 'pbs',
                        type: 'column'
                    },
                    title: {
                        text: 'PBS Coverage'
                    },
                    subtitle: {
                        text: 'Disaggregated by Sex'
                    },
                    xAxis: {
                        categories: ['Female', 'Male', '', '']
                    },
                    yAxis: [{ // Primary yAxis
                        gridLineWidth: 0,
                        minorGridLineWidth: 0,
                        labels: {
                            format: '{value}',
                            style: {
                                color: '#000'
                            }
                        },
                        title: {
                            text: 'Active Patients',
                            style: {
                                color: '#000'
                            }
                        }
                    }, { // Secondary yAxis
                        title: {
                            text: '% Covered',
                            rotation: 270,
                            style: {
                                color: '#000'
                            }
                        },
                        gridLineWidth: 0,
                        minorGridLineWidth: 0,
                        min: 0,
                        max: 100,
                        //labels: {
                        //    format: '{value}%',
                        //    style: {
                        //        color: Highcharts.getOptions().colors[1]
                        //    }
                        //},
                        opposite: true,
                        showFirstLabel: false,
                        showLastLabel: true
                    }],
                    legend: {
                        align: 'left',
                        x: 50,
                        verticalAlign: 'bottom',
                        y: 22,
                        floating: false,
                        backgroundColor: 'white',
                        borderColor: '#fff',
                        borderWidth: 0,
                        shadow: false
                    },
                    tooltip: {
                        shared: true
                    },
                    plotOptions: {
                        column: {
                            grouping: false,
                            shadow: false,
                            borderWidth: 0
                        }
                    },
                    colors: ['rgb(124,181,236)', '#B4C7E7', 'rgb(144,237,125)', '#7030A0', '#4472C4'], //#7030A0
                    series:
                        [
                            { name: 'Female Active', data: [femaleCounts[0], null, null, null], type: 'column', pointWidth: 65, pointPadding: 0.3, pointPlacement: 0.2, tooltip: { valueSuffix: '' } },
                            { name: 'PBS-Female', data: [femalePbs[0], null, null, null], type: 'column', pointWidth: 55, pointPadding: 0.4, pointPlacement: 0.2, tooltip: { valueSuffix: '' } },
                            { name: 'Male Active', data: [null, maleCounts[0], null, null], type: 'column', pointWidth: 65, pointPadding: 0.3, pointPlacement: 0.2, tooltip: { valueSuffix: '' } },
                            { name: 'PBS-Male', data: [null, malePbs[0], null, null], type: 'column', pointWidth: 55, pointPadding: 0.4, pointPlacement: 0.2, tooltip: { valueSuffix: '' } },
                            { name: 'PBS Coverage', data: [null, null, percentagePbsCoverage[0], null], yAxis: 1, type: 'scatter', marker: { radius: 4 }, tooltip: pbsToolTip, dataLabels: { enabled: true, format: '{point.y:,.1f}%' } }
                        ]
                });           

            //Render age band Aggregate data on Pie chart
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pie-agg',
                        plotShadow: false,
                        type: 'pie'
                    },
                    title: { text: 'TX_CURR By Age band' },
                    credits: { enabled: false },
                    exporting: { enabled: false },
                    tooltip: {
                        pointFormat: 'total: {point.y} ({point.percentage:.1f}%)'
                    },
                    plotOptions:
                    {
                        pie:
                        {
                            dataLabels:
                            {
                                enabled: true,
                                format: '<b>{point.y}({point.percentage:.1f} %)',
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        innerSize: '50%',
                        data: tx_curr_ages,
                        type: 'pie'
                    }]
                });

        }

        el.getAgeGenderBand(site);
    }

    async getAgeGenderBand(site) {
        var url2 = `/api/Stats/getTxCurrBandsBySite?site=` + site;
        this.setState({ fLoading: false });

        let res2 = await fetchData(url2);
        let el = this;

        if (res2.length > 0) {
            let males: number[] = [];
            let females: number[] = [];

            res2.map(function (p: any)
            {
                if (p.gender.toLowerCase() === "female") females.push(-p.ageCount);
                if (p.gender.toLowerCase() === "male") males.push(p.ageCount);
            });

            var categories = [
                '0-4', '5-9', '10-14', '15-19',
                '20-24', '25-29', '30-34', '35-39', '40-44',
                '45-49', '50+ '
            ];

            Highcharts.chart(
                {
                    chart: {
                        renderTo: 'band',
                        type: 'bar'
                    },
                    title:
                    {
                        useHTML: true,
                        text: 'TX_CURR Disagrgregated by Age and Sex'
                    },
                    subtitle: {
                        text: 'Active Clients (+28 Days)'
                    },
                    xAxis: [{
                        categories: categories,
                        reversed: false,
                        labels: {
                            step: 1
                        }
                    }, { // mirror axis on right side
                        opposite: true,
                        reversed: false,
                        categories: categories,
                        linkedTo: 0,
                        labels: {
                            step: 1
                        }
                    }],
                    yAxis: {
                        title: {
                            text: null
                        },
                        labels: {
                            formatter: function (val) {
                                return Math.abs(parseFloat(val.value.toString())).toString();
                            }
                        }
                    },

                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },

                    tooltip: {
                        formatter: function () {
                            let nmb: number = this.point.y !== undefined ? this.point.y : 0;
                            return '<b>' + this.series.name + ', age ' + this.point.category + '</b><br/>' +
                                'No. of Clients: ' + nmb !== undefined ? (Highcharts.numberFormat(Math.abs(nmb), 0)).toString() : '0';
                        }
                    },

                    series: [{
                        name: 'Male',
                        data: males,
                        type: 'bar'
                    }, {
                        name: 'Female',
                        data: females,
                        type: 'bar'
                    }]
                });
        }
    }

    closeView()
    {
        this.setState({ showDetails: false });
    }

    render()
    {
        const { confirmLoading, fLoading, hideUpload, showDetails, facility, searchText } = this.state;
        let el = this;
        const user = this.props.appUser;

        const columns =
            [
                {
                    title: 'State',
                    dataIndex: 'stateCode',
                    key: 'stateCode',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                title: 'Facility',
                dataIndex: 'name',
                key: 'name',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Datim Code',
                    dataIndex: 'datimCode',
                    key: 'datimCode',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Total Clients',
                    dataIndex: 'totalClients',
                    key: 'totalClients',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                    // sorter: true
                },
                {
                    title: 'Clients Enroled on ART',
                    dataIndex: 'totalOnArt',
                    key: 'totalOnArt',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-b" key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                    // sorter: true
                },
                {
                    title: 'Active (+28 days)',
                    dataIndex: 'totalActive',
                    key: 'totalActive',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-g" key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                    // sorter: true
                },
                 {
                     title: 'Active (+90 days)',
                     dataIndex: 'inactive',
                     key: 'inactive',
                     render: (value: any, row: any, index: any) => <span className="tb-span db-h3-n" key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                     // sorter: true
                 },
                 {
                    title: 'TX_NEW (in this Quarter)',
                     dataIndex: 'txNew',
                     key: 'txNew',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-br " key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                },
                {
                    title: 'Last Data Upload',
                    dataIndex: 'lastDataUploadDate',
                    key: 'lastDataUploadDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                }
            ];   

        const props =
        {
            name: 'file',
            multiple: false,
            accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            beforeUpload: (file: any) =>
            {
                el.upload(file);
                return false;
            }
        };

        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Facilities</title>
                </Helmet>                
                <div className="custom-filter-dropdown" style={{ display: showDetails ? 'none' : 'block' }}>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Sites</h4>
                        </Col>
                    </Row>
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={3} lg={3}>
                            <Select className="top-10-margin" defaultValue="10" id="pageSize" onChange={(v) => this.handleChange(v)}>
                                <Option value="10">10</Option>
                                <Option value="25">25</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                                <Option value="200">200</Option>
                                <Option value="500">500</Option>
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search by name or State code..." value={searchText} onChange={(s) => el.onInputChange(s)} onPressEnter={() => el.onSearch()} />                                                       
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Button disabled={fLoading} className="login-button top-10-margin" id="push-btn" key="submit" size="large" onClick={() => this.onSearch()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'left', marginLeft: '5px', width: '100%' }} icon={<SearchOutlined />}>
                                <span id="buttonText">Search</span>
                            </Button>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            {(user && user.role === "1") ?
                                <Button disabled={confirmLoading} className="login-button top-10-margin" id="push-btn" loading={confirmLoading} key="submit" type="primary" size="large" onClick={() => this.startUpload()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width:'95%' }} >
                                    <span id="buttonText">{!confirmLoading ? 'Upload Facilities' : 'Processing...'}</span>
                                </Button> : ''}  
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col span={24} style={{overflow: "scroll"}}>
                            <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                        </Col>
                    </Row>
                </div>

                <div className="ul-nfo custom-filter-dropdown" style={{ display: showDetails ? 'block' : 'none' }}>
                    <div className="ant-modal-content">
                        <button title="Close" type="button" aria-label="Close" onClick={() => this.closeView()} className="ant-modal-close">
                            <span className="ant-modal-close-x">
                                <CloseCircleOutlined />
                            </span>
                        </button>
                        <div className="ant-modal-header">
                            <div className="hdr-h">
                                {facility.name}, {facility.stateCode}
                            </div>
                        </div>
                        {fLoading && <img className="waiter" src={busyGif} alt="" style={{ width: '54px', height: '54px' }} />}
                        <div className="ant-modal-body">
                            <Row className="sr row-30px-pad-10px-top">
                                <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                                    <Card className="ant-card-body pfs s-list">
                                        <div className="custom-image">
                                            <h3 className="db-h3 db-h3-i">{String(facility.totalOnArt).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                        </div>
                                        {/*<TeamOutlined className="db-i" />*/}
                                        <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                                        </svg>
                                        <div className="custom-card" title="View more">
                                            <h3>Clients Enroled on ART&nbsp;</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                                    <Card className="ant-card-body pfs s-list">
                                        <div className="custom-image">
                                            <h3 className="db-h3 db-h3-g">{String(facility.active).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                        </div>
                                        {/*<UsergroupAddOutlined className="db-i" />*/}
                                        <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                                        </svg>
                                        <div className="custom-card">
                                            <h3>TX_CURR (+28 days)&nbsp;</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                                    <Card className="ant-card-body pfs s-list">
                                        <div className="custom-image">
                                            <h3 className="db-h3 db-h3-n">{String(facility.inactive).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                        </div>
                                        {/*<SolutionOutlined className="db-i" />*/}
                                        <svg className="bi bi-list-ol db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M5 11.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z" clipRule="evenodd" />
                                            <path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 01-.492.594v.033a.615.615 0 01.569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 00-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z" />
                                        </svg>
                                        <div className="custom-card" title="View more">
                                            <h3>TX_CURR (+90 days)&nbsp;</h3>
                                        </div>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                                    <Card className="ant-card-body pfs s-list">
                                        <div className="custom-image">
                                            <h3 className="db-h3 db-h3-b">{String(facility.newClients).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                        </div>
                                        {/*<CarryOutOutlined className="db-i"/>*/}
                                        <svg className="bi bi-person-plus db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm4.5 0a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z" clipRule="evenodd" />
                                            <path fillRule="evenodd" d="M13 7.5a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0v-2z" clipRule="evenodd" />
                                        </svg>
                                        <div className="custom-card">
                                            <h3>Tx_new (in this Quarter)</h3>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                        <div className="ant-modal-footer cl-ant">
                            <div className="dashboard" style={{ backgroundColor: 'rgb(240, 242, 245, 0.15)' }}>  
                                <Row gutter={2} className="row-30px-pad-10px-top state-txcurr" >
                                    <Col className="ant-card-bordered" xs={24} sm={24} md={12} lg={12} xl={12} id="pvls"></Col>
                                    <Col span={1}></Col>
                                    <Col className="ant-card-bordered" xs={24} sm={24} md={11} lg={11} xl={11} id="pbs"></Col>
                                </Row>
                                <Row gutter={2} className="row-30px-pad-10px-top top-20px state-txcurr">
                                    <Col span={24}></Col>
                                    <Col className="ant-card-bordered" xs={24} sm={24} md={17} lg={17} xl={17} id="band"></Col>
                                    <Col span={1}></Col>
                                    <Col className="ant-card-bordered" xs={24} sm={24} md={6} lg={6} xl={6} id="pie-agg"></Col>
                                </Row> 
                            </div>
                        </div>
                    </div>
                </div> 

                <div className="md-wrapper">
                    <Modal className="modal-width-400 c-modal-body"
                        visible={hideUpload}
                        title= 'Upload Facilities'
                        maskClosable={false}
                        onCancel={() => this.exit()}
                        footer={[
                            
                        ]}>

                        <Form>
                            <div className='ant-row'>
                                <div className='ant-col-24 padding-md'>
                                    <Item> 
                                        <Dragger disabled={this.state.confirmLoading} {...props}>
                                            <p className="ant-upload-drag-icon">
                                                {<InboxOutlined disabled={this.state.confirmLoading}  />}
                                            </p>
                                            <p className="ant-upload-text">
                                                {this.state.confirmLoading ? 'Processing...please wait' : 'Click or drag file to this area to upload'}
                                            </p>
                                        </Dragger>

                                        <Button disabled={this.state.confirmLoading} className="top-15-margin" onClick={() => this.dwnTemplate()} style={{ float: 'left' }}>
                                            Download Template
                                        </Button>
                                    </Item>                                    
                                </div>
                            </div>
                        </Form>
                    </Modal>                    
                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Site as any);
